import { render, staticRenderFns } from "./International.vue?vue&type=template&id=f720d882&scoped=true"
import script from "./International.vue?vue&type=script&lang=js"
export * from "./International.vue?vue&type=script&lang=js"
import style1 from "./International.vue?vue&type=style&index=1&id=f720d882&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f720d882",
  null
  
)

export default component.exports